import { render, staticRenderFns } from "./CompProfileEditPets.vue?vue&type=template&id=374c5cc6&scoped=true"
import script from "./CompProfileEditPets.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileEditPets.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c5cc6",
  null
  
)

export default component.exports